import { FormControl, FormErrorMessage } from '@chakra-ui/react';
import { Form, FormikProps } from 'formik';
import React from 'react';
import FormLabel from '~/components/FormLabel/FormLabel';
import Input from '~/components/Input';

import { NameAndPlatformValues } from './NameAndPlatform.types';
import { NameAndPlatformPlatforms } from './components';

export const NameAndPlatform = React.forwardRef<
  HTMLFormElement,
  FormikProps<NameAndPlatformValues>
>(
  (
    { errors, handleBlur, handleChange, handleSubmit, isSubmitting, values },
    ref,
  ) => {
    return (
      <>
        <Form onSubmit={handleSubmit} ref={ref}>
          <FormControl id="name" isInvalid={!!errors.name} marginBottom={6}>
            <FormLabel fontWeight={400} fontSize="md">
              Name this Media Pack
            </FormLabel>
            <Input
              value={values.name}
              isDisabled={isSubmitting}
              onBlur={handleBlur}
              onChange={handleChange}
              placeholder="Example: Charlie - Skincare July"
              size="md"
              type="text"
              width="100%"
              maxWidth="300px"
            />
            <FormErrorMessage data-testid="error-name">
              {errors.name}
            </FormErrorMessage>
          </FormControl>

          <FormControl
            id="platforms"
            isInvalid={!!errors.platforms}
            marginBottom={6}
          >
            <FormLabel fontWeight={400} fontSize="md" marginBottom={6}>
              Choose the platforms that will be included in this media pack:
            </FormLabel>

            <NameAndPlatformPlatforms
              onBlur={handleBlur}
              onChange={handleChange}
              values={values}
            />
            <FormErrorMessage data-testid="error-platforms">
              {errors.platforms}
            </FormErrorMessage>
          </FormControl>
        </Form>
      </>
    );
  },
);
